import { api } from '@/config/api';

export type CalendarEventType = 'appointment' | 'follow_up' | 'meeting' | 'call' | 'task' | 'reminder' | 'other';
export type CalendarEventStatus = 'scheduled' | 'completed' | 'cancelled' | 'no_show';

export interface CalendarEvent {
  _id: string;
  eventUid: string;
  companyUid: string;
  contactUid?: string;
  leadUid?: string;
  assigneeUserUid?: string;
  type: CalendarEventType;
  status: CalendarEventStatus;
  title: string;
  description?: string;
  location?: string;
  startsAt: string;
  endsAt: string;
  allDay: boolean;
  createdByUserUid: string;
  reminderMinutesBefore?: number;
  reminderSentAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertCalendarEventInput {
  type: CalendarEventType;
  title: string;
  description?: string;
  location?: string;
  startsAt: string;
  endsAt: string;
  allDay?: boolean;
  contactUid?: string;
  leadUid?: string;
  assigneeUserUid?: string;
  reminderMinutesBefore?: number;
}

const BASE = '/slighter_crm/calendar';

export interface VirtualCalendarEntry {
  eventUid: string;
  companyUid: string;
  type: 'reminder';
  status: 'scheduled';
  title: string;
  description?: string;
  startsAt: string;
  endsAt: string;
  allDay: true;
  assigneeUserUid?: string;
  contactUid?: string;
  leadUid?: string;
  kind: 'deal_close' | 'task_due';
  sourceEntityType: 'deal' | 'task';
  sourceEntityUid: string;
}

export const calendarService = {
  list: async (params: {
    from?: string; to?: string;
    assigneeUserUid?: string; contactUid?: string;
    type?: CalendarEventType; status?: CalendarEventStatus;
  } = {}): Promise<CalendarEvent[]> =>
    (await api.get(BASE, { params })).data,

  listCombined: async (params: {
    from?: string; to?: string;
    assigneeUserUid?: string;
  } = {}): Promise<{ events: CalendarEvent[]; virtual: VirtualCalendarEntry[] }> =>
    (await api.get(`${BASE}/combined`, { params })).data,

  get: async (uid: string): Promise<CalendarEvent> =>
    (await api.get(`${BASE}/${uid}`)).data,

  create: async (payload: UpsertCalendarEventInput): Promise<CalendarEvent> =>
    (await api.post(BASE, payload)).data,

  update: async (uid: string, payload: Partial<UpsertCalendarEventInput> & { status?: CalendarEventStatus }): Promise<CalendarEvent> =>
    (await api.patch(`${BASE}/${uid}`, payload)).data,

  remove: async (uid: string): Promise<{ ok: boolean }> =>
    (await api.delete(`${BASE}/${uid}`)).data,

  getMyFeed: async (): Promise<{ url: string; token: string }> =>
    (await api.get(`${BASE}/feed/me`)).data,

  rotateMyFeed: async (): Promise<{ url: string; token: string }> =>
    (await api.post(`${BASE}/feed/me/rotate`)).data,
};
